var shopNavigation = {

	selectors: {
		element: '.shop__navigation',
		item: '.shop__navigation__item--parent--0',
		link: '.shop__navigation__link'
	},

	state: {
		positionTop: 0,
	},

	init: function() {
		var self = this,
		$element     = $( self.selectors.element ),
		$parentItems = $element.find( self.selectors.item ),
		$parentLinks = $parentItems.children( self.selectors.link );

		if ( $element.length > 0 ) {
			self.sticky( $element );

			$parentLinks.on( 'click', function(e) {
				var $link = $( this ),
				$parentItem = $link.parent( self.selectors.item );

				if ( $parentItem.hasClass( 'opened' ) === false ) {
					e.preventDefault();

					$parentItems.removeClass( 'opened' );
					$element.addClass( 'item-opened' );
					$parentItem.addClass( 'opened' );

					$( document.body ).on( 'touchstart.shop-navigation click.shop-navigation', function(e) {
						if ( ! $( e.target ).closest( self.selectors.element ).length ) {
							$element.removeClass( 'item-opened' );
							$parentItems.removeClass( 'opened' );
							$( document.body ).off( '.shop-navigation' );
						}
					} );
				}

			} );
		}
	},

	sticky: function( $element ) {
		var self = this;

		var headerHeight = $( '#site-header' ).outerHeight();
		self.state.positionTop = $element.offset().top - headerHeight;

		$( window ).on( 'scroll', function() {
            var scrollTop = $( window ).scrollTop();

            if ( scrollTop > 0 ) {
            	$element.addClass( 'sticky' );
            } else {
            	$element.removeClass( 'sticky' );
            }
        } );
	}

};

export { shopNavigation }